import React from 'react';
import {
  BookOpen,
  FileText,
  CreditCard,
  Package,
  Tag,
  LineChart,
  Users,
  Boxes,
  Inbox,
  ShoppingCart,
  LayoutTemplate,
  Settings,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  PanelLeftClose,
  PanelLeftOpen,
  Search,
  Check,
  Info,
  CornerDownLeft,
  Repeat,
  Menu,
  Gift,
} from 'lucide-react';

// Maps the kebab-case icon names emitted by `hub_nav_sections` (Rails) and used
// throughout the shell to their lucide-react components. Keeping the import list
// explicit lets webpack tree-shake to only these icons.
const ICONS = {
  'book-open': BookOpen,
  'file-text': FileText,
  'credit-card': CreditCard,
  package: Package,
  tag: Tag,
  'line-chart': LineChart,
  users: Users,
  boxes: Boxes,
  inbox: Inbox,
  'shopping-cart': ShoppingCart,
  'layout-template': LayoutTemplate,
  settings: Settings,
  gift: Gift,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-right': ChevronRight,
  'panel-left-close': PanelLeftClose,
  'panel-left-open': PanelLeftOpen,
  search: Search,
  check: Check,
  info: Info,
  'corner-down-left': CornerDownLeft,
  repeat: Repeat,
  menu: Menu,
};

// Thin 1.75 stroke matches the prototype's Lucide rendering.
const Icon = ({ name, size = 18, color = 'currentColor', style }) => {
  const Cmp = ICONS[name] || Boxes;
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={1.75}
      style={{ flex: 'none', display: 'block', ...style }}
      aria-hidden="true"
    />
  );
};

export default Icon;
